import gsap from "gsap";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import React, { Component } from "react";
import Hammer from 'hammerjs';
import Config from "../../constants/Config";
import Image from "../atoms/Image";
import { Parallax } from "react-scroll-parallax";

const { cmsPrefix } = Config;

gsap.registerPlugin(ScrollToPlugin);

export default class Slider extends Component {
    timer = null;
    scrollView = React.createRef();
    container = React.createRef();
    scrollBar = React.createRef();
    animation = null;

    clsHasScroll = 'has-scrollbar';

    constructor(props) {
        super(props);
        this.state = {
            topReached: true,
            endReached: false,
            isDesktop: window.matchMedia("(min-width: 1024px)").matches,
            visible: false,
            maxX: 0,
            scrollbarPerc: 0,
            containerWidth: 0,
            curXScrollbarPos: 0,
        };

        this.scrollOffset = 425;

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        };
    }

    componentDidMount() {
        window
            .matchMedia("(min-width: 1024px)")
            .addEventListener("change", e => {
                this.setState({ isDesktop: e.matches })
                this.scrollView.current.removeEventListener('scroll', () => {
                    this.scrollbarTrackHandler();
                })
                this.scrollView.current.addEventListener('scroll', () => {
                    this.scrollbarTrackHandler();
                })
        });

        this.setState({
            endReached: this.hasReachedEnd(),
            topReached: this.hasReachedTop(),
        });

        this.scrollbarLayout();
        this.attachScrollbarHandler();

        window.addEventListener('resize', () => {
			this.scrollbarLayout();
            this.attachScrollbarHandler();
		});

        this.scrollView.current.addEventListener('scroll', () => {
            this.scrollbarTrackHandler();
        })
    }

    scrollbarTrackHandler() {
		if (this.state.isDesktop) {
			return false;
		}

		let perc = 100 - ((this.scrollBar.current.children[0].offsetWidth / this.scrollBar.current.offsetWidth) * 100);
		let xPerc = (this.scrollView.current.scrollLeft / this.state.maxX) * 100;
		let x = (xPerc / 100) * perc;
		this.scrollBar.current.children[0].style.left = `${x}%`;
	}

    scrollbarLayout() {
        let containerWidth = this.scrollView.current.scrollWidth - this.scrollView.current.clientWidth;

		this.setState({
            scrollBarPerc: (this.scrollBar.current.children[0].offsetWidth / this.scrollBar.current.offsetWidth) * 100,
            maxX: Math.abs(containerWidth),
        });
	}

    // On move of scrollbar, move $inner
	attachScrollbarHandler() {
		let mouseDown = (window.Modernizr.touch) ? 'touchstart' : 'mousedown';

		window.addEventListener(mouseDown, () => {
			this.setState({
                curXScrollbarPos: this.scrollView.current.scrollLeft
            })
		});

		let hammertime = new Hammer(this.scrollBar.current.children[0]);
		hammertime.on('panleft panright', (ev) => {
            let targetX = this.state.curXScrollbarPos + (ev.deltaX * 2);
			this.scrollView.current.scrollLeft = `${targetX}`;
		});
	}

    scrollToEnd = () => {
        // window.ga("send", "event", "UNO", "Carousel Click", "RightArrow");
        this.stopAnimation();
        const nodeStyle = window.getComputedStyle(this.container.current);
        const distance =
            window.innerWidth -
            2 * parseFloat(nodeStyle.marginLeft.replace("px", "")) -
            2 * parseFloat(nodeStyle.paddingLeft.replace("px", ""));

        // console.log(this.scrollView.current.scrollLeft);
        // console.log(distance);
        this.animation = gsap.to(this.scrollView.current, {
            duration: 0.5,
            scrollTo: {
                x: this.scrollView.current.scrollLeft + distance,
            },
            ease: "power1.inOut",
        });
    };

    scrollToTop = () => {
        this.stopAnimation();
        const nodeStyle = window.getComputedStyle(this.container.current);
        const distance =
            window.innerWidth -
            2 * parseFloat(nodeStyle.marginLeft.replace("px", "")) -
            2 * parseFloat(nodeStyle.paddingLeft.replace("px", ""));
        this.animation = gsap.to(this.scrollView.current, {
            duration: 0.5,
            scrollTo: {
                x: this.scrollView.current.scrollLeft - distance,
            },
            ease: "power1.inOut",
        });
    };

    stopAnimation = () => {
        if (this.animation) {
            this.animation.kill();
        }
    };

    onScroll = () => {
        this.setState({
            endReached: this.hasReachedEnd(),
            topReached: this.hasReachedTop(),
        });
    };

    hasReachedEnd() {
        return (
            this.scrollView.current.offsetWidth +
                this.scrollView.current.scrollLeft >=
            this.scrollView.current.scrollWidth
        );
    }
    hasReachedTop() {
        return this.scrollView.current.scrollLeft <= 0;
    }
    render() {
        return (
            <div className="carousel-slider">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-xs-12 carousel-slider__heading-section">
                            <h2 className="priority-3">{this.props.heading}</h2>
                            <div className="carousel-slider__control">
                                <Image
                                    src={
                                        cmsPrefix +
                                        "/assets/images/shake-win-left-arrow.svg"
                                    }
                                    onClick={this.scrollToTop}
                                    className={`carousel-slider__arrow left ${
                                        this.state.topReached ? "disabled" : ""
                                    }`}
                                />
                                <Image
                                    src={
                                        cmsPrefix +
                                        "/assets/images/shake-win-right-arrow.svg"
                                    }
                                    onClick={this.scrollToEnd}
                                    className={`carousel-slider__arrow right ${
                                        this.state.endReached ? "disabled" : ""
                                    }`}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div
                            className="col-xs-12"
                            ref={this.container}
                        >
                            {this.state.isDesktop ? (
                                <div
                                    onScroll={this.onScroll}
                                    ref={this.scrollView}
                                    className="carousel-slider__inner"
                                >
                                    {this.props.children}
                                </div>
                            ) : (
                                <Parallax
                                    x={["75px", "0px"]}
                                    easing="easeInOutQuad"
                                >
                                    <div
                                        onScroll={this.onScroll}
                                        ref={this.scrollView}
                                        className="carousel-slider__inner"
                                    >
                                        {this.props.children}
                                    </div>
                                </Parallax>
                            )}
                        </div>
                        <div className={`carousel-scroll ${!this.state.isDesktop ? 'is-visible' : ''}`}>
                            <div className="container-fluid-lg">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="carousel-scrollbar" ref={this.scrollBar}>
                                            <div className="carousel-scrollbar-track"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
